import * as angular from "angular";

angular
  .module('bringoz.admin.notifications')
  .constant('TextTemplates_PN', {
    database: 'text-templates',
    isBranchEntity: false
  });
